import React, { memo } from 'react';

const QuotePartnerSiteLoadingState: React.FC = () => {
  return (
    <div>
      <div className="px-10 py-6 bg-loading/background-2">
        <div className="w-40 h-8 bg-system/white rounded-lg" />
      </div>
      <div className="bg-loading/background-1 p-10 h-60 flex items-center justify-center">
        <div className="w-48 h-14 rounded-xl bg-loading/background-2" />
      </div>
    </div>
  );
};

export default memo(QuotePartnerSiteLoadingState);
